import React, { useState } from 'react';
import '../styles/CharacterInput.scss';
interface CharacterInputProps {
  onCharacterSubmit: (character: string) => void;
}
const CharacterInput: React.FC<CharacterInputProps> = ({ onCharacterSubmit }) => {
  const [character, setCharacter] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (character.trim()) {
      onCharacterSubmit(character);
      setCharacter('');
    }
  };
  return (
    <div className="character-input-container">
      <form onSubmit={handleSubmit} className="character-form">
        <div className="input-wrapper">
          <input
            type="text"
            value={character}
            onChange={(e) => setCharacter(e.target.value)}
            className="character-input"
            placeholder="Введите иероглиф"
            maxLength={1}
          />
          <div className="character-display">
            {character && <span className="large-character">{character}</span>}
          </div>
        </div>
        <button type="submit" className="submit-button">
          Добавить
        </button>
      </form>
    </div>
  );
};
export default CharacterInput; 